import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/lm-master-front/app/[locale]/dynamic-head-tags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/lm-master-front/app/[locale]/gtm-page-view-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/nexts/lm-master-front/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/lm-master-front/app/[locale]/registry.tsx");
;
import(/* webpackMode: "eager" */ "/home/nexts/lm-master-front/app/global.css");
;
import(/* webpackMode: "eager" */ "/home/nexts/lm-master-front/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/lm-master-front/src/entities/data-confirmation/model/confirm-initializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GamingLimitsHardModalHost"] */ "/home/nexts/lm-master-front/src/features/profile/ui/gaming-limits/gaming-limits-hard-modal-host.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TwaInitializer"] */ "/home/nexts/lm-master-front/src/shared/hooks/useTwaDetect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChunkErrorReloadInitializer"] */ "/home/nexts/lm-master-front/src/shared/libs/chunk-error-reload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FullscreenProvider"] */ "/home/nexts/lm-master-front/src/shared/providers/fullscreen-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationGuardProvider"] */ "/home/nexts/lm-master-front/src/shared/providers/navigation-guard-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevBrandSwitcher"] */ "/home/nexts/lm-master-front/src/shared/ui/dev-tools/dev-brand-switcher/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterApps"] */ "/home/nexts/lm-master-front/src/shared/ui/footer/client/apps.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactsDisclosure"] */ "/home/nexts/lm-master-front/src/shared/ui/footer/client/contacts-disclosure.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterLanguage"] */ "/home/nexts/lm-master-front/src/shared/ui/footer/client/footer-language.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterPageText"] */ "/home/nexts/lm-master-front/src/shared/ui/footer/client/page-text.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentActions"] */ "/home/nexts/lm-master-front/src/shared/ui/footer/client/payment-actions.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelfExclusionAccordion"] */ "/home/nexts/lm-master-front/src/shared/ui/footer/client/self-exclusion-accordion.client.tsx");
;
import(/* webpackMode: "eager" */ "/home/nexts/lm-master-front/src/shared/ui/footer/server-footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSync"] */ "/home/nexts/lm-master-front/src/shared/ui/selects/select-language/locale-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMenuButton"] */ "/home/nexts/lm-master-front/src/widgets/header/header-menu-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderRightSlot","HeaderBannersSlot"] */ "/home/nexts/lm-master-front/src/widgets/header/header-right-slot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderScrollDecoration"] */ "/home/nexts/lm-master-front/src/widgets/header/header-scroll-decoration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderVisibilityController"] */ "/home/nexts/lm-master-front/src/widgets/header/header-visibility-controller.tsx");
;
import(/* webpackMode: "eager" */ "/home/nexts/lm-master-front/src/widgets/header/server-header.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/home/nexts/lm-master-front/src/widgets/layouts/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopSideMenu"] */ "/home/nexts/lm-master-front/src/widgets/side-menu/desktop-side-menu.tsx");
